import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Injectable()
export class AuthorizationNumberService {
  public authInvalid = false;

  onInput(event: InputEvent, input: AbstractControl) {
    const target = event.target as Element;

    // Prevent showing red error until they are done typing
    target.classList.remove('ng-dirty', 'ng-invalid');

    if (input.valid) {
      this.authInvalid = false;
    }
  }

  onBlur(event: FocusEvent, input: AbstractControl) {
    const target = event.target as Element;

    if (input.valid) {
      target.classList.remove('ng-dirty', 'ng-invalid');
      this.authInvalid = false;
    } else {
      this.authInvalid = true;
      target.classList.add('ng-dirty', 'ng-invalid');
    }
  }

  onPaste(event: ClipboardEvent, input: AbstractControl) {
    // Prevents paste without going through validation
    event.preventDefault();

    const alphaNumRegex = new RegExp('^[a-zA-Z0-9]*$');
    const pastedData = event.clipboardData.getData('text')?.trim();
    if (pastedData && alphaNumRegex.test(pastedData)) {
      input.setValue(pastedData);
    }

    input.updateValueAndValidity({ emitEvent: false });
  }
}
